<template>
  <div class="greybox">
    <h1>Please provide copies of all repair documentation...</h1>
    <p
      class="lead"
    >Please provide copies of your payment receipt and work authorisation and service confirmation paperwork.</p>
    <p class="lead">
      <i class="fas fa-info-circle"></i> Remember to click Upload when you have selected a file(s)
    </p>
    <h3>Payment receipt</h3>
    <upload
      :entityRef="selectedClaim.id"
      :entityType="1000"
      :fileType="1008"
      :optionRef="optionRef"
      v-model="uploadResponse"
      @status="handleStatusChange"
    ></upload>
    <h3 class="mt-3">Work authorisation / service confirmation</h3>
    <upload
      :entityRef="selectedClaim.id"
      :entityType="1000"
      :fileType="1008"
      :optionRef="optionRef"
      v-model="uploadResponse"
      @status="handleStatusChange"
    ></upload>

    <button class="button mt-5" @click="handleCloseClick()">Back to claim</button>
  </div>
</template>
<script>
import repairOptionsBase from "@/mixins/repairOptionsBase";
import upload from "@/components/Upload";

const DEFAULT_PATH = "/";

export default {
  components: {
    upload
  },
  mixins: [repairOptionsBase],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // check for login and keep default...
      let { path } = from;

      if (path != "/login") {
        vm.referer = path;
      }
    });
  },
  beforeMount() {
    //this.loadOptions(this.selectedGadgetId)
    this.loadSelectedClaim(this.selectedGadgetId);
  },
  data: () => {
    return {
      uploadComponentStatus: 0,
      uploadResponse: {}
    };
  },
  computed: {
    optionRef() {
      if (this.selectedGadget && this.selectedGadget.repairOption) {
        return this.selectedGadget.repairOption.webReference;
      } else {
        null;
      }
    }
  },
  methods: {
    handleStatusChange(status) {
      this.uploadComponentStatus = status;
    },
    handleCloseClick() {
      // this.$router.push({ path: this.referer }) <-- original
      // this.$router.push({ path: '/myclaims/list' }); <-- no id route
      this.$router.push({ path: "/myclaims/view/" + this.selectedClaim.id }); // <--id route
    }
  }
};
</script>
